import { ShipmentStatus } from '#/shared/api/generated/shipment/models'

export const TRAVEL_PROGRESS = {
  booked: 'booked',
  transit: 'transit',
  delivered: 'delivered',
} as const

export type TravelProgress =
  (typeof TRAVEL_PROGRESS)[keyof typeof TRAVEL_PROGRESS]

export function shipmentTravelProgress(
  status: string | undefined,
): TravelProgress {
  if (status === ShipmentStatus.completed) return TRAVEL_PROGRESS.delivered
  if (status === ShipmentStatus.picked_up) return TRAVEL_PROGRESS.transit
  return TRAVEL_PROGRESS.booked
}
